(function () {
  if (window.__tsvGiftBundlesLoaded) return;
  window.__tsvGiftBundlesLoaded = true;

  /* -----------------------------
     Helpers
  ----------------------------- */
  function truthy(v) {
    return v === true || v === 1 || v === '1' || v === 'true';
  }

  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function fetchCartJson() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function changeCartItemByKey(lineItemKey, qty) {
    var payload = { id: lineItemKey, quantity: qty };

    return fetch('/cart/change.js?upcart=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (r) { return r.json(); })
    .catch(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); });
    });
  }

  // Explicit gift markers (if present)
  function isExplicitGift(props) {
    return props && (truthy(props._tsv_gift) || !!props._tsv_gift_group);
  }

  // Parent discovery line marker
  function isDiscoveryParent(props) {
    return props && truthy(props._tsv_is_discovery);
  }



  /* -----------------------------
    UpCart repaint hook (debounced)
  ----------------------------- */
  var __tsvUpcartRefreshTimer = null;
  function refreshUpcartSoon(delay) {
    if (delay == null) delay = 0;
    clearTimeout(__tsvUpcartRefreshTimer);
    __tsvUpcartRefreshTimer = setTimeout(function () {
      try {
        if (typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        } else if (window.upcart && typeof window.upcart.refreshCart === 'function') {
          window.upcart.refreshCart();
        }
      } catch (e) {}
    }, delay);
  }

  /* -----------------------------
    Core reconcile
     GOAL:
      - If discovery parent removed -> remove gift children
      - If gift qty > total discovery qty in that bundle -> clamp down
      - NEVER auto-increase gift qty (customer can choose 1..max)
      - If gift line exists and qty < 1 (shouldn't happen) -> set to 1
  ----------------------------- */
  function reconcileGiftBundles() {
    return fetchCartJson().then(function (cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var parentQtyByBundle = {};
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var bundle = props._tsv_bundle;
      if (!bundle) return;

      if (isDiscoveryParent(props)) {
        parentQtyByBundle[bundle] = (parentQtyByBundle[bundle] || 0) + (item.quantity || 0);
      }
    });

      var didChangeAnything = false;

      var tasks = cart.items.map(function (item) {
        return function () {
      var props = item.properties || {};
      var bundle = props._tsv_bundle;

          // Only touch bundled children (gifts)
        var child = isExplicitGift(props);

          if (!child) return Promise.resolve();

          // No bundle on a child? remove it
      if (!bundle) {
            didChangeAnything = true;
            return changeCartItemByKey(item.key, 0).catch(function () {});
      }

      var parentQty = parentQtyByBundle[bundle] || 0;

          // Parent removed -> remove children
      if (parentQty === 0) {
            didChangeAnything = true;
            return changeCartItemByKey(item.key, 0).catch(function () {});
      }

          // ===== CHANGE FOR YOUR NEW RULE =====
          // Let customer set gift qty anywhere from 1..parentQty.
          // We ONLY clamp down if it exceeds parentQty.
          // We DO NOT force it to match parentQty anymore.
      var currentQty = toInt(item.quantity, 1);
      var desiredQty = currentQty;

      if (desiredQty < 1) desiredQty = 1;
      if (desiredQty > parentQty) desiredQty = parentQty;

          if (currentQty !== desiredQty) {
            didChangeAnything = true;
            return changeCartItemByKey(item.key, desiredQty).catch(function () {});
          }

          return Promise.resolve();
        };
      });

      return tasks.reduce(function (p, fn) {
        return p.then(fn);
      }, Promise.resolve())
      .then(function () {
        if (didChangeAnything) {
    refreshUpcartSoon(0);
    refreshUpcartSoon(120);
        }
      });
    });
  }

  window.tsvReconcileGiftBundles = reconcileGiftBundles;

  /* -----------------------------
    Debounced scheduler
  ----------------------------- */
  var __tsvTimer = null;
  var __tsvBusy = false;

  function scheduleReconcile(delay) {
    if (delay == null) delay = 70;

    clearTimeout(__tsvTimer);
    __tsvTimer = setTimeout(function () {
      if (__tsvBusy) return;
      __tsvBusy = true;

      Promise.resolve()
        .then(function () { return reconcileGiftBundles(); })
        .catch(function () {})
        .finally(function () { __tsvBusy = false; });

    }, delay);
  }

  function scheduleReconcileBurst() {
    scheduleReconcile(40);
    scheduleReconcile(160);
    scheduleReconcile(420);
  }

  /* -----------------------------
    FETCH WRAP (re-wrap if overwritten)
  ----------------------------- */
  function makeFetchWrapper(realFetch) {
    if (realFetch && realFetch.__tsvWrapped) return realFetch;

    function wrappedFetch() {
      var url = arguments[0];
      try { url = (typeof url === 'string') ? url : (url && url.url) || ''; } catch (e) { url = ''; }

      var isCartWrite =
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1;

      var p = realFetch.apply(this, arguments);

      if (isCartWrite) {
        p.then(function () { scheduleReconcileBurst(); }).catch(function () {});
      }

      return p;
    }

    wrappedFetch.__tsvWrapped = true;
    wrappedFetch.__tsvOriginal = realFetch;
    return wrappedFetch;
  }

  (function installFetchGuard() {
    if (window.__tsvFetchGuardInstalled) return;
    window.__tsvFetchGuardInstalled = true;

    var current = window.fetch;
    var wrapped = makeFetchWrapper(current);

    try {
      Object.defineProperty(window, 'fetch', {
        configurable: true,
        get: function () { return wrapped; },
        set: function (newFetch) {
          current = newFetch;
          wrapped = makeFetchWrapper(current);
        }
      });
    } catch (e) {
      window.fetch = wrapped;
    }
  })();

  /* -----------------------------
    XHR watcher (UpCart sometimes uses XHR)
  ----------------------------- */
  (function installXhrWatcher() {
    if (window.__tsvXhrWatcherInstalled) return;
    window.__tsvXhrWatcherInstalled = true;

    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__tsv_url = url || '';
      return open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__tsv_url || '';

      var isCartWrite =
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1;

      if (isCartWrite) {
        xhr.addEventListener('load', function () { scheduleReconcileBurst(); });
      }

      return send.apply(this, arguments);
    };
  })();

  /* -----------------------------
    Events + initial cleanup
  ----------------------------- */
  document.addEventListener('upcart:cart_updated', function () { scheduleReconcileBurst(); });
  document.addEventListener('cart:updated', function () { scheduleReconcileBurst(); });

  setTimeout(function () { scheduleReconcileBurst(); }, 220);
})();
